import VyjadreniaAdminStartPage from './VyjadreniaAdminStartPage';

export default VyjadreniaAdminStartPage;
